import cardActionAreaClasses from "@mui/material/CardActionArea/cardActionAreaClasses";
export const getCardBorderRadius = (dt) => {
    return dt.borderRadius.medium;
};
export const MuiCardTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                hasPixelTheme: "true",
                display: "flex",
                flexDirection: "column",
                position: "relative",
                borderRadius: getCardBorderRadius(dt),
                background: dt.color.surface.key,
                boxShadow: dt.elevation.level1,
                "&::after": {
                    pointerEvents: "none",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    border: `${dt.borderWidth.xSmall} solid ${dt.color.system.neutrals[95]}`,
                    borderRadius: getCardBorderRadius(dt),
                    content: '""',
                },
                [`&:has(.${cardActionAreaClasses.root}:hover):not(:has(.${cardActionAreaClasses.root} :where(button:hover, a:hover)))`]: {
                    boxShadow: dt.elevation.level2,
                },
            },
        },
    };
};
